import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SubsectionCard from './SubsectionCard';
import { SectionType } from './DonutNavigation';
import { dashboardSections } from '../../config/dashboardSections';
import { dashboardTheme } from '../../styles/dashboardTheme';

interface SectionContentProps {
  section: SectionType;
  onSubsectionClick: (subsectionId: string) => void;
}

const SectionContent: React.FC<SectionContentProps> = ({ section, onSubsectionClick }) => {
  const sectionData = dashboardSections.find(s => s.id === section);
  if (!sectionData) return null;

  const sectionColor = dashboardTheme.sections[section].primary;

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={section}
        className="w-full"
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -100 }}
        transition={{ duration: 0.4, ease: 'easeOut' }}
      >
        {/* Section header */}
        <motion.div
          className="mb-8"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <h2 className="text-4xl font-bold mb-2" style={{ color: sectionColor }}>
            {sectionData.title}
          </h2>
          <p className="text-gray-500 text-lg">Explore detailed insights and analytics</p>
        </motion.div>

        {/* Subsections grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {sectionData.subsections.map((subsection, index) => {
            const Icon = subsection.icon;
            return (
              <SubsectionCard
                key={subsection.id}
                title={subsection.title}
                description={subsection.description}
                icon={<Icon className="w-7 h-7" />}
                color={sectionColor}
                onClick={() => onSubsectionClick(subsection.id)}
                delay={0.1 * index}
              />
            );
          })}
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default SectionContent;

